/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const MENU_NAME_MODEL = {
    COMPANY: 'company',
    ZONES: 'zones',
    DEVICE: 'device',
    ATTENDANCE: 'attendance',
    DEPARTMENTS: 'departments',
    EMPLOYEES: 'employees',
    VEHICLES: 'vehicles',
    RESERVATIONS: 'reservations',
    CONTROLLER: 'controller',
    WORK_SHIFT_PANEL: 'workShiftPanel',
    ACCESS: 'access',
    PRIVILEGE_SETTINGS: 'privilegeSettings',
    ONBOARDING: 'onBoarding',
    CONTRACTORS: 'contractors',
    SUPPLIER: 'supplier',
    GUARD: 'guard',
    DOCUMENT_PANEL: 'documentPanel',
    EMAIL_SETTINGS: 'emailSettings',
    BACKUP: 'backUp',
    WORK_OFFICE: 'workOffice',
    CARD_DESIGNER: 'cardDesigner',
    LOGS: 'logs',
    DELETE: 'delete',
    GRAPHS: 'graphs',
    CARDS: 'cards',
    DINING_MANAGEMENT: 'diningManagement',
    FOODIE_DINING: 'foodieDining',
    PROFILE: 'profile',
    SYSTEM_CONFIG: 'systemConfig',
    DISTRIBUTION_CENTER: 'distributionCenter',
    APPROVAL: 'approval',
    SERVICE_TYPE: 'serviceType',
    TRANSPORT_REQUEST: 'transportRequest',
    VISITOR_MANAGEMENT: 'visitorManagement',
    BUILDINGS: 'buildings',
    MY_APARTMENTS: 'my_apartments',
    TRAFFIC_MAIN_SYSTEM: 'trafficMainSystem',
    KITCHEN_TICKETS: 'kitchenTickets',
    INCOMING_INVITATIONS: 'incomingInvitations',
    INCOMING_CONTRACTOR: 'incomingContractor',
    DELIVERED_SERVICES: 'deliveredServices',
    ORDERS: 'orders',
    COMPANY_DOCUMENTATION: 'companyDocumentation',
    CONTRACTS: 'contracts',
    ACCESS_RIGHTS: 'accessRights',
    EQUIPMENT_MATERIAL_CONTROL: 'equipmentMaterialControl',
    SIOS: 'sios',
    READERS: 'readers',
    INPUTS: 'inputs',
    OUTPUTS: 'outputs',
    ACRS: 'acrs',
    ACCESS_MONITORING: 'accessMonitoring',
    EVENT_MONITORING: 'eventMonitoring'
};
